import React from "react";
import styled from "styled-components";

function ListGroupHeader({ label }: { label: string }) {
  return (
    <SListGroupHeader>
      <span>{label}</span>
    </SListGroupHeader>
  );
}

export default ListGroupHeader;

// #region Styles

const SListGroupHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 8px;
  background: ${(p) => p.theme.color.grey5};
  font: ${(p) => p.theme.font.normal};
`;

// #endregion
